/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Transaction_NoInputs */

const en_admin_credits_transaction_no = /** @type {(inputs: Admin_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction No`)
};

/**
* | output |
* | --- |
* | "Transaction No" |
*
* @param {Admin_Credits_Transaction_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_transaction_no = /** @type {((inputs?: Admin_Credits_Transaction_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Transaction_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_transaction_no(inputs)
});
export { admin_credits_transaction_no as "admin.credits.transaction_no" }